
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/win-a-home-renovation-spotdif",
      function () {
        return require("private-next-pages/landing/win-a-home-renovation-spotdif.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/win-a-home-renovation-spotdif"])
      });
    }
  